<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
});

const activeIndex = ref(null);

const setActiveIndex = (index) => (activeIndex.value = index);
</script>

<template>
  <div class="ui-accordion">
    <UiToggle
      v-for="(item, index) in items"
      :key="index"
      :title="$t(item.title)"
      :is-opened-outside="activeIndex === index"
      class="ui-accordion__toggle"
      @toggle="(opened) => setActiveIndex(opened ? index : null)"
    >
      <div class="ui-accordion__content">
        <slot :item="item" :index="index" :is-open="activeIndex === index" />
      </div>
    </UiToggle>
  </div>
</template>

<style scoped lang="scss">
.ui-accordion {
  &__toggle {
    & + & {
      margin-top: em(25);
    }
  }

  &__content {
    padding-top: em(23);
  }
}
</style>
